<div class="padding-bottom">
  <h3 class="first">{{name}}</h3>
  <p-dropdown [options]="options"
              (onChange)="updateClient()"
              [(ngModel)]="clientData[model]"
              placeholder="Select"></p-dropdown>

  <div class=""
       *ngIf="settings">
    <span *ngFor="let item of settings">
      <div *ngIf="item?.size == 'full' && item?.type == 'string'"
           class="sm-padding-top col-md-12">
        <label>{{item?.text}}</label>
        <input (change)="updateClient()"
               class="full-width"
               pInputText
               name="{{item?.name}}"
               [(ngModel)]="clientData[dataName][item?.name]" />
      </div>

      <div *ngIf="item?.size == 'small' && item?.type == 'string'"
           class="sm-padding-top col-md-4">
        <label>{{item?.text}}</label>
        <input (change)="updateClient()"
               class="full-width"
               pInputText
               name="{{item?.name}}"
               [(ngModel)]="clientData[dataName][item?.name]" />
      </div>

      <div *ngIf="item?.type == 'textarea'"
           class="sm-padding-top col-md-12">
        <label>{{item?.text}}</label>
        <textarea pInputTextarea
                  (change)="updateClient()"
                  name="{{item?.name}}"
                  class="full-width text-area-box"
                  [(ngModel)]="clientData[dataName][item?.name]"></textarea>

      </div>


      <div *ngIf="item?.size == 'small' && item?.type == 'color'"
           class="sm-padding-top col-md-4">
        <label>{{item?.text}}
          <div class="color-block"
               [ngStyle]="{'background': clientData[dataName][item?.name]}"></div>
        </label>
        <input (change)="updateClient()"
               class="full-width"
               pInputText
               name="{{item?.name}}"
               [(ngModel)]="clientData[dataName][item?.name]" />
        <a class="color-link"
           (click)="updateColor(item?.name, clientData.primaryHex)">
          Pr:
          <div class="color-circle"
               [ngStyle]="{'background': clientData.primaryHex}"></div>
        </a>
        &nbsp;
        <a class="color-link"
           (click)="updateColor(item?.name, clientData.accentHex)">
          Acc:
          <div class="color-circle"
               [ngStyle]="{'background': clientData.accentHex}"></div>
        </a>
        &nbsp;
        <a class="color-link"
           (click)="updateColor(item?.name, 'rgba(255, 255, 255, 1)')">
          RGBA
        </a>
        <a class="color-link"
           (click)="updateColor(item?.name, 'linear-gradient(rgba(0,0,0,.65),rgba(0,0,0,.65)), url() ')">
          IMG
        </a>
      </div>


      <div *ngIf="item?.size == 'small' && item?.type == 'boolean'"
           class="col-md-6 sm-padding-top">
        <md-slide-toggle [(ngModel)]="clientData[dataName][item?.name]"
                         (change)="updateClientSlideToggle($event, item?.name)">{{item?.text}}</md-slide-toggle>
      </div>


      <div *ngIf="item?.size == 'full' && item?.type == 'boolean'"
           class="col-md-12 sm-padding-top">
        <md-slide-toggle [(ngModel)]="clientData[dataName][item?.name]"
                         (change)="updateClientSlideToggle($event, item?.name)">{{item?.text}}</md-slide-toggle>
      </div>

      <div *ngIf="item?.size == 'small' && item?.type == 'selection'"
           class="col-md-6 sm-padding-top">
        <label>{{item?.text}}</label>
        <p-dropdown [options]="item?.options"
                    name="{{item?.name}}"
                    class="full-width"
                    (onChange)="updateClient()"
                    [(ngModel)]="clientData[dataName][item?.name]"
                    placeholder="Select"></p-dropdown>
      </div>

      <div *ngIf="item?.size == 'full' && item?.type == 'selection'"
           class="col-md-12 sm-padding-top">
        <label>{{item?.text}}</label>
        <p-dropdown [options]="item?.options"
                    name="{{item?.name}}"
                    class="full-width"
                    (onChange)="updateClient()"
                    [(ngModel)]="clientData[dataName][item?.name]"
                    placeholder="Select"></p-dropdown>
      </div>
    </span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/components/component-structure/component-structure.component.html